/* unplugin-vue-components disabled */import { render } from "./SpeachCell.vue?vue&type=template&id=33154eae&scoped=true&ts=true"
import script from "./SpeachCell.vue?vue&type=script&lang=ts"
export * from "./SpeachCell.vue?vue&type=script&lang=ts"

import "./SpeachCell.vue?vue&type=style&index=0&id=33154eae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33154eae"]])

export default __exports__